import { loadable } from 'nordic/lazy';
import highlightedSpecsMapAttrs from './highlighted-specs-map-attrs';

const HighlightedSpecsAttrs = loadable(() =>
  import('../../../../components/highlighted-specs/highlighted-sepcs-attrs.mobile'),
);

export default highlightedSpecsMapAttrs(HighlightedSpecsAttrs);
